import type { ReactNode } from 'react';
import './Badge.css';

export type BadgeTone = 'neutral' | 'brand' | 'accent' | 'success' | 'warning' | 'danger';

export interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
  /**
   * Text prefix carrying the meaning for users who cannot perceive the colour
   * (section 12: colour is never the only indicator).
   */
  srPrefix?: string;
}

export function Badge({ tone = 'neutral', srPrefix, children }: BadgeProps) {
  return (
    <span className={`sc-badge sc-badge--${tone}`}>
      {srPrefix && <span className="sc-visually-hidden">{srPrefix}: </span>}
      {children}
    </span>
  );
}
